import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  space,
  color,
  typography,
  shadow,
  layout,
  variant,
  compose,
  system,
} from 'styled-system'

const variants = ({ breakpoints } = {}) => ({
  h1: {
    fontSize: '3.25rem',
    fontWeight: 'bold',
    lineHeight: '4rem',
    color: 'text.primary',
    [`@media screen and (min-width: ${breakpoints.md})`]: {
      fontSize: '2.8125rem',
      fontWeight: 'semiBold',
      lineHeight: '3.5rem',
      color: 'text.primary',
    },
  },
  h2: {
    fontSize: '3rem',
    fontWeight: 'bold',
    lineHeight: '3.75rem',
    color: 'text.primary',
    [`@media screen and (min-width: ${breakpoints.md})`]: {
      fontSize: '3.75rem',
      fontWeight: 'semiBold',
      lineHeight: '3.5rem',
    },
  },
  h3: {
    fontSize: '1.875rem',
    fontWeight: 'semiBold',
    lineHeight: '110%',
    color: 'text.primary',
    [`@media screen and (min-width: ${breakpoints.md})`]: {
      fontSize: '2.5rem',
      lineHeight: '100%',
    },
  },
  h4: {
    fontSize: '1.5rem',
    fontWeight: 'semiBold',
    lineHeight: '1.5rem',
    color: 'text.primary',
  },
  h5: {
    fontSize: '1.25rem',
    fontWeight: 'semiBold',
    lineHeight: '1.25rem',
    color: 'text.primary',
  },
})

const style = system({
  textTransform: true,
  whiteSpace: true,
  cursor: true,
})

const StyleHeading = compose(space, color, typography, shadow, layout, style)

const Heading = styled.h3.attrs(({ variant = 'h2' }) => ({
  as: variant,
}))(
  (props) => ({
    padding: 0,
    margin: 0,
    textTransform: props.uppercase ? 'uppercase' : 'inherit',
  }),
  ({ theme: { breakpoints } }) =>
    variant({
      variants: variants({ breakpoints }),
    }),
  StyleHeading,
  ({ sx }) => sx,
)

Heading.propTypes = {
  textAlign: PropTypes.string,
  textTransform: PropTypes.string,
  whiteSpace: PropTypes.string,
  as: PropTypes.node,
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5']).isRequired,
  sx: PropTypes.object,
  children: PropTypes.node,
  uppercase: PropTypes.any,
}

export default Heading
